import React, { PureComponent, Fragment } from 'react'
import { Route } from 'react-router-dom'

import { connect } from 'react-redux'
// local components
import ThirdPartyAccounts from '../ThirdParty'
/* import Headset from './Headset' */
import Weedmaps from './Weedmaps'
import WebHooks from './WebHooks'
import ComplianceContainer from './ComplianceContainer'
import OnFleet from './OnFleet'
import SpringBig from './SpringBig'
import QuickBook from './QuickBook'
import Tookan from './Tookan'
import Spence from './Spence'
import MTrac from './MTrac'
import Clover from './Clover'
import Leafly from './Leafly'
import { getCompanyFeatures } from '../../../actions/company'
import Stronghold from './Stronghold'
import WmDispatch from './WmDispatch'
import WmDispatchShopInfo from '../../../components/WmDispatch/WmDispatchShopInfo'
import { RouteConstants } from '../../../utils/constants'

class IntegrationPage extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isSpenceEnable: false,
    }
  }

  isSpenceAvailable() {
    const { authReducer = {}, companyReducer = {} } = this.props
    const { companyFeatures = {} } = companyReducer
    const { spencePaymentByShops = {} } = companyFeatures

    let shopId =
      authReducer.session && authReducer.session.assignedShop && authReducer.session.assignedShop.id
    let spencePaymentShopIds = Object.keys(spencePaymentByShops)
    if (spencePaymentShopIds.length === 0 || !Boolean(shopId)) {
      return !!false
    }

    return !!Boolean(spencePaymentByShops[shopId])
  }

  isStrongholdAvailable() {
    const { authReducer = {}, companyReducer = {} } = this.props
    const { companyFeatures = {} } = companyReducer
    const { strongholdPaymentByShops = {} } = companyFeatures

    let shopId =
      authReducer.session && authReducer.session.assignedShop && authReducer.session.assignedShop.id
    let strongholdPaymentShopIds = Object.keys(strongholdPaymentByShops)
    if (strongholdPaymentShopIds.length === 0 || !Boolean(shopId)) {
      return !!false
    }

    return !!Boolean(strongholdPaymentByShops[shopId])
  }

  isWMDispatchAvailable() {
    const { authReducer = {}, companyReducer = {} } = this.props
    const { companyFeatures = {} } = companyReducer
    const { wmDispatch = [] } = companyFeatures

    let shopId =
      authReducer.session && authReducer.session.assignedShop && authReducer.session.assignedShop.id
    let wmDispatchIds = Object.keys(wmDispatch)

    if (wmDispatchIds.length === 0 || !Boolean(shopId) || !wmDispatch[shopId]) {
      return !!false
    }

    return !!Boolean(wmDispatch[shopId].enable)
  }

  render() {
    const { match } = this.props
    return (
      <Fragment>
        <Route exact path={`${match.url}/`} component={ThirdPartyAccounts} />
        <Route exact path={`${match.url}/weedmaps`} component={Weedmaps} />
        <Route exact path={`${match.url}/webhooks`} component={WebHooks} />
        <Route exact path={RouteConstants.COMPLIANCE().PERMISSIONS_PAGE} component={ComplianceContainer} />
        <Route exact path={`${match.url}/onfleet`} component={OnFleet} />
        {this.isWMDispatchAvailable() && (
          <Route exact path={`${match.url}/wmDispatch`} component={WmDispatch} />
        )}
        {this.isWMDispatchAvailable() && (
          <Route exact path={`${match.url}/wmDispatch/:id`} component={WmDispatchShopInfo} />
        )}
        <Route exact path={`${match.url}/springbig`} component={SpringBig} />
        <Route exact path={`${match.url}/tookan`} component={Tookan} />
        {this.isSpenceAvailable() && (
          <Route exact path={`${match.url}/spence`} component={Spence} />
        )}
        <Route exact path={`${match.url}/leafly`} component={Leafly} />
        {this.isStrongholdAvailable() && (
          <Route exact path={`${match.url}/stronghold`} component={Stronghold} />
        )}
      </Fragment>
    )
  }
}

export default connect((state) => ({
  dispatch: state.dispatch,
  authReducer: state.authReducer,
  companyReducer: state.companyReducer,
}))(IntegrationPage)



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/IntegrationPage.js